import { render, staticRenderFns } from "./BarChartCardLoadsByProduct.vue?vue&type=template&id=3bd5f836&"
import script from "./BarChartCardLoadsByProduct.vue?vue&type=script&lang=js&"
export * from "./BarChartCardLoadsByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports